<template>
  <div class="tab-items-list" v-if="isAuth?.is_active">
    <template v-if="storeNomenclatures.length === 0">
      <div class="tab-items-list__create">
        <span class="tab-items-list__create-text">Ещё нет номенклатуры.</span>
        <span class="tab-items-list__create-text">
          Создайте новую или загрузите через Excel.
        </span>

        <div class="tab-items-list__btns-group">
          <div>
            <button
              @click="showNomenclatureModal"
              :disabled="state.preloader"
              class="btn btn-primary"
            >
              Создать новую
            </button>
          </div>

          <div>
            <input type="file" ref="fileRef" hidden @change="uploadFile" />
            <button
              class="btn btn-primary tab-items-list__btn"
              @click="fileRef.click()"
              :disabled="state.preloader"
            >
              Загрузить из Excel
              <div><iconExcel /></div>
            </button>
          </div>
          <div>
            <button
              class="btn btn-primary tab-items-list__btn"
              @click="downloadFile"
              :disabled="state.preloader"
            >
              Скачать шаблон
              <div><iconExcel /></div>
            </button>
          </div>
        </div>
      </div>
    </template>

    <PreloaderComponent
      v-if="state.preloader"
      class="tab-items-list__preloader"
    />

    <template v-if="storeNomenclatures.length > 0">
      <div class="tab-items-list__bar">
        <div class="tab-items-list__bar-controls">
          <QInput
            outlined
            v-model="pagination.query"
            @keyup.enter="getNomenclature"
            :dense="dense"
            placeholder="Поиск номенклатуры"
            class="tab-rules__bar-search"
          >
            <template v-slot:append>
              <iconSearch
                iconColor="#21212180"
                @click="getNomenclature"
              ></iconSearch> </template
          ></QInput>
          <button
            class="btn-link flex"
            @click="showNomenclatureModal"
            :disabled="state.preloader"
          >
            Добавить
            <div><iconPlus /></div>
          </button>
        </div>

        <div class="tab-items-list__bar-wrapp">
          <div>
            <input type="file" ref="fileRef" hidden @change="uploadFile" />
            <button
              class="btn btn-primary tab-items-list__btn"
              :disabled="state.preloader"
              @click="fileRef.click()"
            >
              Загрузить из Excel
              <div><iconExcel /></div>
            </button>
          </div>
          <div>
            <button
              class="btn btn-primary tab-items-list__btn"
              :disabled="state.preloader"
              @click="downloadFile"
            >
              Скачать шаблон
              <div><iconExcel /></div>
            </button>
          </div>
        </div>
      </div>
      <div class="tab-items-list__table-wrapp">
        <div class="t-table">
          <div class="t-table-row t-table-head">
            <div class="t-table-cell">Артикул</div>
            <div class="t-table-cell">Штрихкод</div>
            <div class="t-table-cell">ШxВxГ, см</div>
            <div class="t-table-cell">Вес, кг</div>
            <div class="t-table-cell">Кол-во слоёв</div>
            <div class="t-table-cell">Кол-во в слое</div>
            <div class="t-table-cell">Хрупкость*</div>
            <div class="t-table-cell">Действия</div>
          </div>

          <div class="t-table-row" v-for="item in nomenclatures" :key="item.id">
            <div class="t-table-cell">{{ item.article }}</div>
            <div class="t-table-cell">{{ item.barcode }}</div>
            <div class="t-table-cell">
              {{ item.width }}х{{ item.height }}х{{ item.depth }}
            </div>
            <div class="t-table-cell">{{ item.weight }}</div>
            <div class="t-table-cell">{{ item.max_layer_height }}</div>
            <div class="t-table-cell">{{ item.max_in_layer }}</div>
            <div class="t-table-cell">{{ item.fragility }}</div>
            <div class="t-table-cell">
              <div class="icon">
                <iconCopy @click="copyNomenclature(item)" />
                <q-tooltip class="bg-tooltip">Копировать</q-tooltip>
              </div>

              <div class="icon">
                <iconEditPen @click="showEditNomenclatureModal(item)" />
                <q-tooltip class="bg-tooltip">Редактировать</q-tooltip>
              </div>

              <div class="icon">
                <iconDelete @click="showDeleteNomenclatureModal(item)" />
                <q-tooltip class="bg-tooltip">Удалить</q-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="padding-bottom: 16px">
        <q-pagination
          v-if="pagination.total > 0"
          v-model="pagination.page"
          :max="Math.ceil(pagination.total / pagination.page_size)"
          direction-links
          boundary-links
          @update:model-value="(value) => setPage(value)"
          :max-pages="5"
        />
      </div>
    </template>
  </div>
  <CreateNomenclatureModal
    ref="createNomenclatureModalRef"
    @reload="getNomenclature()"
  />
  <EditNomenclatureModal
    :currentItem="form.data"
    ref="editNomenclatureModalRef"
    @reload="getNomenclature()"
    @copyNomenclature="copyNomenclature"
  />
  <DeleteModal
    :dataProps="form.data"
    ref="deleteNomenclatureModalRef"
    @submit="remove"
  >
    Удалить номенклатуру {{ form.data.article }}?
  </DeleteModal>
  <SubmitAccountModal ref="submitAccountRef" />
</template>

<script lang="ts">
import { defineComponent, ref, computed, reactive, onMounted } from 'vue';
import type {
  modalType,
  INomenclature,
  userType,
  IPagination,
} from '@/types/common';
import { QCheckbox, QTooltip, QPagination, QInput } from 'quasar';
import iconEditPen from '@/components/icons/iconEditPen.vue';
import iconCopy from '@/components/icons/iconCopy.vue';
import iconPlus from '@/components/icons/iconPlus.vue';
import iconSearch from '@/components/icons/iconSearch.vue';
import iconDelete from '@/components/icons/iconDelete.vue';
import iconExcel from '@/components/icons/iconExcel.vue';
import CreateNomenclatureModal from '@/pages/nomenclature/CreateNomenclatureModal.vue';
import EditNomenclatureModal from '@/pages/nomenclature/EditNomenclatureModal.vue';
import DeleteModal from '@/pages/modalsProfile/DeleteModal.vue';
import SubmitAccountModal from '@/components/header/SubmitAccountModal.vue';
import { useDataStore } from '@/store/dataStore';
import { useAuthStore } from '@/store/authStore';
import * as dictionaryService from '@/api/dictionaryService';
import PreloaderComponent from '@/components/shared/PreloaderComponent.vue';
import { showError, showMessage } from '@/utils/errorsInterceptor';
interface IState {
  preloader: boolean;
}

interface IInitData {
  id: number | null;
  article: string;
  depth: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  barcode: string;
  fragility: number | null;
  max_layer_height: number | null;
  max_in_layer: number | null;
}
interface IForm {
  data: IInitData;
  file: File[];
}

const initData = () => ({
  id: null,
  article: '',
  depth: null,
  width: null,
  height: null,
  weight: null,
  barcode: '',
  fragility: null,
  max_layer_height: null,
  max_in_layer: null,
});

export default defineComponent({
  name: 'NomenclaturePage',
  components: {
    iconEditPen,
    iconExcel,
    iconSearch,
    QTooltip,
    QPagination,
    CreateNomenclatureModal,
    EditNomenclatureModal,
    DeleteModal,
    QCheckbox,
    iconPlus,
    iconCopy,
    iconDelete,
    QInput,
    PreloaderComponent,
    SubmitAccountModal,
  },
  setup() {
    const isAuth = computed((): userType | null => authStore.userStore);
    const dataStore = useDataStore();
    const authStore = useAuthStore();
    const user = computed((): userType | null => authStore.getUser);
    const createNomenclatureModalRef = ref<modalType | null>(null);
    const editNomenclatureModalRef = ref<modalType | null>(null);
    const deleteNomenclatureModalRef = ref<modalType | null>(null);
    const nomenclatures = ref<INomenclature[]>([]);
    const storeNomenclatures = computed(
      (): INomenclature[] => dataStore.nomenclatures
    );

    const state: IState = reactive({
      preloader: false,
    });

    const form: IForm = reactive({
      data: initData(),
      file: [],
    });

    const pagination: IPagination = reactive({
      page: 1,
      page_size: 20,
      total: 0,
      query: '',
    });
    const dense = ref(true);
    const fileRef = ref<any>(null);

    const showNomenclatureModal = () => {
      if (createNomenclatureModalRef.value) {
        createNomenclatureModalRef.value.isOpen = true;
      }
    };

    const copyNomenclature = (nomenclature: INomenclature) => {
      if (
        createNomenclatureModalRef.value &&
        createNomenclatureModalRef.value.showModal
      ) {
        createNomenclatureModalRef.value.showModal(nomenclature);
      }
    };

    const showEditNomenclatureModal = (item: INomenclature) => {
      if (editNomenclatureModalRef.value) {
        form.data = {
          id: item.id,
          article: item.article,
          depth: item.depth,
          width: item.width,
          height: item.height,
          weight: item.weight,
          max_layer_height: item.max_layer_height,
          max_in_layer: item.max_in_layer,
          barcode: item.barcode,
          fragility: item.fragility,
        };

        editNomenclatureModalRef.value.isOpen = true;
      }
    };

    const showDeleteNomenclatureModal = (item: INomenclature) => {
      if (deleteNomenclatureModalRef.value) {
        form.data.id = item.id;
        form.data.article = item.article;
        deleteNomenclatureModalRef.value.isOpen = true;
      }
    };

    const remove = async (data) => {
      state.preloader = true;
      try {
        const response = await dictionaryService.deleteNomenclature(data.id);
        state.preloader = false;
        showMessage('Номенклатура удалена');
        getNomenclature();
      } catch (error: any) {
        state.preloader = false;
        showError(error);
      }
    };

    const getNomenclature = async () => {
      if (user.value?.newbie) {
        dataStore.loadMainData();
      }
      try {
        state.preloader = true;
        const response = await dictionaryService.getNomenclature(pagination);
        state.preloader = false;
        pagination.total = response.headers['x-total-count'] ?? 0;
        if (response?.data) {
          nomenclatures.value = response?.data;
          dataStore.loadMainData();
        }
      } catch (error: any) {
        state.preloader = false;
        showError(error);
      }
    };

    const setPage = (page: number) => {
      pagination.page = page;
      getNomenclature();
    };

    onMounted(() => {
      if (isAuth.value?.is_active === true) {
        getNomenclature();
        dataStore.loadMainData();
      } else {
        showSubmitAccount();
      }
    });

    const uploadFile = async (event): Promise<void> => {
      let file = event.target.files;
      if (file?.[0]) {
        file = file[0];
      }

      const formData = new FormData();
      formData.append('file', file);

      try {
        state.preloader = true;
        const response = await dictionaryService.importExcel(formData);
        state.preloader = false;
        showMessage(response.data.message);
        getNomenclature();
      } catch (error) {
        state.preloader = false;
        showError(error);
      }
    };

    const onClickUploadBtn = (): void => {
      if (fileRef.value) {
        fileRef.value.click();
      }
    };

    const downloadFile = async (): Promise<void> => {
      state.preloader = true;
      try {
        const response = await dictionaryService.downloadFile();
        state.preloader = false;
        if (response) {
          const blob_file = response.data;
          const file_url = URL.createObjectURL(blob_file);
          const link = document.createElement('a');
          link.href = file_url;
          link.setAttribute('download', 'nomenclature-template.xlsx');
          link.setAttribute('id', 'temporaryLinkFile');
          document.body.appendChild(link);
          link.click();
          (document.querySelector('#temporaryLinkFile') as any).remove();
        }
      } catch (error) {
        state.preloader = false;
        showError(error);
      }
    };

    const showSubmitAccount = () => {
      if (submitAccountRef.value) {
        submitAccountRef.value.isOpen = true;
      }
    };

    const submitAccountRef = ref<modalType | null>(null);
    return {
      createNomenclatureModalRef,
      editNomenclatureModalRef,
      deleteNomenclatureModalRef,
      showNomenclatureModal,
      showEditNomenclatureModal,
      showDeleteNomenclatureModal,
      form,
      nomenclatures,
      storeNomenclatures,
      state,
      getNomenclature,
      remove,
      copyNomenclature,
      uploadFile,
      fileRef,
      onClickUploadBtn,
      downloadFile,
      pagination,
      setPage,
      dense,
      isAuth,
      submitAccountRef,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/scss/tabs/tab-items-list.scss';
</style>
